angular.module('picmonicng').component('homeTopPoints', {
  templateUrl: '/templates/app/components/home-top-points/home-top-points.html',
  bindings: {},
  controller: [
    '$rootScope',
    '$state',
    'UserService',
    'User',
    'SpacedRep',
    'SpacedRepetitionDisclaimerModal',
    function ($rootScope, $state, UserService, User, SpacedRep, SpacedRepetitionDisclaimerModal) {
      var ctrl = this;
      ctrl.UserService = UserService;
      timezone = moment.tz.guess();
      if (!UserService.user.settings.timezone) {
        UserService.user.settings.timezone = timezone;
      }

      // Spaced rep stats
      ctrl.spacedrep = User.getv3({
        resource: 'spacedrepstats',
        timezone: timezone,
      });

      // Quiz accuracy
      ctrl.stats = User.getv3({
        resource: 'stats',
        resource_id: 'facts',
      });

      // XP
      User.queryv3(
        {
          resource: 'xp',
        },
        function (result) {
          ctrl.xp = result[6].xp;
        }
      );

      $rootScope.$on('xp', function (evt, data) {
        ctrl.xp = ctrl.xp + data.amount;
      });

      ctrl.newSpacedRep = function () {
        User.savev3({ resource: 'spacedrep' }, function (result) {
          SpacedRep.start(result.next);
        });
      };

      ctrl.goToStats = function () {
        $('.home-my-stats')[0].scrollIntoView();
      };

      ctrl.goToAchievements = function () {
        $('.home-achievements')[0].scrollIntoView();
      };

      ctrl.toggleOpen = function () {
        ctrl.open = !ctrl.open;
      };

      ctrl.scrollIntoView = function (id) {
        const element = document.getElementById(id);

        if (element === null) {
          return;
        }

        element.scrollIntoView({
          behavior: 'smooth',
        });
      };

      ctrl.handleDailyQuizOnClick = () => {
        if (ctrl.spacedrep.next === undefined || ctrl.spacedrep.next === 0) {
          return SpacedRepetitionDisclaimerModal.show();
        }

        return ctrl.newSpacedRep();
      };
    },
  ],
});
